// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/swiper-bundle.css';

// // init Swiper:
// const swiper = new Swiper('.swiper-container', {
//   // configure Swiper to use modules
//   modules: [Navigation, Pagination],
//     direction: 'horizontal',
//     loop: true,

//     // If we need pagination
//     // pagination: {
//     //     el: '.swiper-pagination',
//     //     clickable: true
//     // },

//     // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper--next',
    //     prevEl: '.swiper--prev',
    // },

//     // And if we need scrollbar
//     // scrollbar: {
//     //     el: '.swiper-scrollbar',
//     // }
// });




const swiperCenter = new Swiper('.center--align--slider', {
    modules: [Navigation],
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 20,
    slideToClickedSlide: true,
    // centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 1.3,
        centeredSlides: false,
      }
    },
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },
});

const coverSlider = new Swiper('.cover--slider', {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
});
